var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _rect17, _rect18, _rect19, _path11, _rect20, _rect21, _rect22, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 47.4842,
    transform: "matrix(3.31001e-10 -1 0.999984 0.00567604 134.766 130.386)",
    fill: "url(#paint0_linear_422_3335)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 47.4842,
    transform: "matrix(-1.3466e-10 -1 -0.999984 0.00567604 499.249 130.386)",
    fill: "url(#paint1_linear_422_3335)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 66.6978,
    transform: "matrix(-0.927791 0.373101 0.367829 0.929893 174.666 214.554)",
    fill: "url(#paint2_linear_422_3335)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 66.6978,
    transform: "matrix(0.925046 0.379856 -0.374599 0.927187 460.739 215.444)",
    fill: "url(#paint3_linear_422_3335)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.676 285.744)",
    fill: "url(#paint4_linear_422_3335)",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.903 286.423)",
    fill: "url(#paint5_linear_422_3335)",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 60.7729,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 136.131 350.872)",
    fill: "url(#paint6_linear_422_3335)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 60.7729,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 498.905 350.815)",
    fill: "url(#paint7_linear_422_3335)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.772,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.636 296.783)",
    fill: "url(#paint8_linear_422_3335)",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.772,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.863 297.462)",
    fill: "url(#paint9_linear_422_3335)",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12123,
    height: 7.77573,
    transform: "matrix(0.999986 0.00445443 0.0029835 -0.999992 291.56 255.846)",
    fill: "url(#paint10_linear_422_3335)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12123,
    height: 7.77573,
    transform: "matrix(0.999986 0.00445443 -0.0029835 0.999992 291.533 264.918)",
    fill: "url(#paint11_linear_422_3335)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12123,
    height: 12.9595,
    transform: "matrix(0.999986 0.00445443 0.0029835 -0.999992 317.015 255.959)",
    fill: "url(#paint12_linear_422_3335)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12123,
    height: 12.9595,
    transform: "matrix(0.999986 0.00445443 -0.0029835 0.999992 316.987 265.031)",
    fill: "url(#paint13_linear_422_3335)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12123,
    height: 7.77573,
    transform: "matrix(0.999986 0.00445443 0.0029835 -0.999992 340.347 256.063)",
    fill: "url(#paint14_linear_422_3335)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12123,
    height: 7.77573,
    transform: "matrix(0.999986 0.00445443 -0.0029835 0.999992 340.32 265.135)",
    fill: "url(#paint15_linear_422_3335)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.121 23.0337H321.621C320.788 22.867 319.121 23.2337 319.121 26.0337C319.121 28.8337 319.121 62.5337 319.121 68.5337",
    stroke: "url(#paint16_linear_422_3335)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.121 23.0337H316.621C317.454 22.867 319.121 23.2337 319.121 26.0337C319.121 28.8337 319.121 62.5337 319.121 68.5337",
    stroke: "url(#paint17_linear_422_3335)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.509 218.143L340.996 132.198C340.923 131.005 341.689 128.796 345.341 129.513L517.077 129.513C518.843 129.14 523.041 129.692 525.705 134.884L569.619 195.314C570.971 197.179 574.494 200.909 577.765 200.909L634.77 200.909",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.282 218.367L295.771 132.341C295.858 131.146 295.116 128.935 291.453 129.652L119.58 129.652C117.817 129.279 113.61 129.832 110.884 135.03L66.2484 195.531C64.8738 197.398 61.3058 201.133 58.0321 201.133L0.981865 201.133",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.728 317.069L294.687 324.231C294.762 325.276 294.285 327.365 291.783 327.365L221.79 327.365C221.149 327.365 219.392 326.111 217.496 321.098C217.08 319.997 215.122 315.175 212.143 307.893M0.863992 221.948L20.9479 221.948M138.266 189.943L138.245 193.524L138.287 186.138M138.266 189.943L149.631 189.943M138.266 189.943L126.901 189.943M149.631 189.943L160.995 189.943C163.112 189.943 164.59 192.33 165.064 193.524C175.268 218.249 191.889 258.563 203.697 287.302M149.631 189.943L149.61 193.524L149.652 186.138M126.901 189.943L115.536 189.943C114.094 189.793 110.531 190.301 107.819 193.524L97.2855 205.945M126.901 189.943L126.881 193.524L126.923 186.138M97.2855 205.945L86.7521 218.367C85.5427 219.561 82.7391 221.948 81.1997 221.948L61.1158 221.948M97.2855 205.945L107.748 205.945L86.8226 205.945M41.0318 221.948L41.0052 226.648M41.0318 221.948L61.1158 221.948M41.0318 221.948L20.9479 221.948M61.1158 221.948L61.0891 226.648M20.9479 221.948L20.9212 226.648M212.143 307.893L223.825 307.893M212.143 307.893C210.901 304.858 209.483 301.396 207.924 297.597M207.924 297.597L223.883 297.597M207.924 297.597C206.607 294.387 205.191 290.937 203.697 287.302M203.697 287.302L223.942 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M339.955 317.069L339.914 324.231C339.828 325.276 340.281 327.365 342.783 327.365L412.776 327.365C413.417 327.365 415.188 326.111 417.141 321.098C417.57 319.997 419.583 315.175 422.644 307.893M634.899 221.948L614.815 221.948M497.86 189.943L497.84 193.524L497.882 186.138M497.86 189.943L486.496 189.943M497.86 189.943L509.225 189.943M486.496 189.943L475.131 189.943C473.014 189.943 471.509 192.33 471.021 193.524C460.537 218.249 443.458 258.563 431.324 287.302M486.496 189.943L486.475 193.524L486.517 186.138M509.225 189.943L520.59 189.943C522.034 189.793 525.591 190.301 528.267 193.524L538.659 205.945M509.225 189.943L509.205 193.524L509.247 186.138M538.659 205.945L549.051 218.367C550.247 219.561 553.024 221.948 554.563 221.948L574.647 221.948M538.659 205.945L528.196 205.945L549.122 205.945M594.731 221.948L594.704 226.648M594.731 221.948L574.647 221.948M594.731 221.948L614.815 221.948M574.647 221.948L574.62 226.648M614.815 221.948L614.788 226.648M422.644 307.893L410.962 307.893M422.644 307.893C423.92 304.858 425.378 301.396 426.98 297.597M426.98 297.597L411.021 297.597M426.98 297.597C428.333 294.387 429.789 290.937 431.324 287.302M431.324 287.302L411.079 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.472 202.028L319.478 24.7674C319.482 24.0213 319.972 22.5292 321.896 22.5292L524.178 22.5292C526.423 22.6039 530.916 21.9921 530.933 18.9482C530.951 15.9043 530.996 7.8321 531.017 4.17647C530.942 3.28121 531.369 1.49069 533.678 1.49069L625.629 1.1582",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.964 202.028L318.467 113.398L318.97 24.7674C318.975 24.0213 318.503 22.5292 316.581 22.5292L114.606 22.5292C112.364 22.6039 115.976 21.8119 115.994 18.7681C116.011 15.7242 116.057 7.65196 116.078 3.99632C116.163 3.10106 107.665 1.49069 105.36 1.49069L11.1427 1.31055",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.721 337.884L317.675 345.941C317.503 347.881 318.219 351.76 322.452 351.76L497.315 351.76C498.597 351.909 502.081 351.044 505.764 346.389L563.418 274.32C564.467 273.052 566.999 270.516 568.731 270.516L634.395 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M316.719 337.884L316.673 345.941C316.822 347.881 316.063 351.76 311.83 351.76L136.967 351.76C135.683 351.909 132.209 351.044 128.579 346.389L71.743 274.32C70.7079 273.052 68.2048 270.516 66.473 270.516L0.80938 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.887 22.7529)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.47559 22.7532)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.14 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.215 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.291 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.362 193.822C575.365 193.41 575.701 193.076 576.113 193.076L584.439 193.076C585.544 193.076 586.434 193.971 586.428 195.076L586.425 195.707C586.419 196.726 585.588 197.552 584.569 197.552L579.072 197.552C577.011 197.552 575.351 195.882 575.362 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.4331 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.3574 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.2817 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2018 193.822C61.2042 193.41 60.872 193.076 60.46 193.076L52.1333 193.076C51.0287 193.076 50.1282 193.971 50.122 195.076L50.1184 195.707C50.1126 196.726 50.9341 197.552 51.9534 197.552L57.4503 197.552C59.5105 197.552 61.1901 195.882 61.2018 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 47.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 47.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_422_3335",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 66.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_422_3335",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 66.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 60.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 60.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_422_3335",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_422_3335",
    x1: 1.06061,
    y1: 7.77573,
    x2: 1.06061,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_422_3335",
    x1: 1.06061,
    y1: 7.77573,
    x2: 1.06061,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_422_3335",
    x1: 1.06061,
    y1: 12.9595,
    x2: 1.06061,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_422_3335",
    x1: 1.06061,
    y1: 12.9595,
    x2: 1.06061,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_422_3335",
    x1: 1.06061,
    y1: 7.77573,
    x2: 1.06061,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_422_3335",
    x1: 1.06061,
    y1: 7.77573,
    x2: 1.06061,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_422_3335",
    x1: 332.621,
    y1: 9.4999,
    x2: 311.191,
    y2: 15.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_422_3335",
    x1: 305.621,
    y1: 9.4999,
    x2: 327.051,
    y2: 15.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame9);
export default __webpack_public_path__ + "static/media/card1-frame9.aa37ee6e9118cd9efef93fa00e63998d.svg";
export { ForwardRef as ReactComponent };